/**
 * --------------------------------------------------------------------------
 * Custom Tooltips for Chart.js (v3.1.2): index.umd.js
 * Licensed under MIT (https://github.com/@coreui/coreui-chartjs/LICENSE)
 * --------------------------------------------------------------------------
 */

// eslint-disable-next-line no-unused-vars
import customTooltips from './src/custom-tooltips.js'

export default {
  customTooltips
}
